import React from "react";

function WelcomePage() {
  return (
    <React.Fragment>
      <h1>Welcome!</h1>
      <p>
        You can upload, view and share your images and videos using this website,
        its source code and more details are available <a href="https://github.com/przemo199/replayer">here</a>
      </p>
    </React.Fragment>
  );
}

export default WelcomePage;
